import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, Divider } from '@material-ui/core'
import SpecificComponent from '../../commons/SpecificComponent';
import FileIcon from '../../providers/FileIcon';
import Ws from '../../providers/Ws';
import generic from '../../Pics/iconsMonitorizare/generic.png'






export default class AddAplicatieNoua extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listProductive: [
                { nume: 'Este neproductiva', id: 0 },
                { nume: 'Este productiva', id: 1 }
            ]
        }
    }

    componentDidMount() {

    }

    ws = new Ws()



    selectFile = (id) => {

        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()

    }

    uploadPoza = async (id) => {


 
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);






        reader.onload = async () => {
            let fileContent = reader.result;

            //  console.log(fileContent);
            console.log('saveFile :', saveFile);


            let uploadImage = await this.ws.uploadimage('Upload/MonitorAppIcon', saveFile, this.props.aplicatie.hash_id);

            console.log('uploadImage :', uploadImage);
            if (uploadImage.Succes) {


                this.props.getData()

            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);


        }
    }


    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    style={{ zIndex: 6000 }}
                    maxWidth={'sm'}
                >
                    <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>


                    <DialogContent>
                        <Grid container>

                            <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>

                            <input type='file' id={`monitorizareIcon`}
                                        style={{ display: 'none' }}
                                        accept='image/png'
                                        onChange={() => { this.uploadPoza('monitorizareIcon') }}
                                    />
                                <div
                                    style={{ display: 'inline-block', marginRight: 20 }}
                                >

                                  
                                    <img
                                        onClick={()=>{this.selectFile('monitorizareIcon')}}
                                        style={{margin:0 , width:30, height:30}}
                                        src={this.props.aplicatie.icon ? `${this.ws.adresaMedia}/monitorizare/icons/${this.props.aplicatie.icon}` : generic}
                                    />

                                </div>
                            </Grid>

                            <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
                                <Grid container>
                                    <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span style={{ marginRight: 20, fontSize: 18, display: 'block', fontWeight: 600 }}>{this.dictionary.monitorizare.aplicatie}</span>
                                    </Grid>

                                    <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <span style={{ marginRight: 20, fontSize: 14, display: 'block' }}>{this.props.aplicatie.nume}</span>
                                    </Grid>

                                </Grid>

                                <Divider style={{ marginTop: 20 }} className="pm-divider" />
                            </Grid>


                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div style={{ position: 'relative', textAlign: 'left' }}>
                                            <input
                                                style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                                id='nume'
                                                type="text"
                                                step='any'
                                                className='add-project-input'
                                                placeholder={''}
                                                margin="normal"
                                                name='nume'
                                                value={this.props.aplicatie.nume || ''}
                                                onChange={this.props.changeAplicatie}
                                            // onBlur={this.props.updateAngajatData}
                                            />
                                            <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.monitorizare.numeAplicatie}</label>
                                        </div>

                                    </Grid>

                                    <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div style={{ position: 'relative', textAlign: 'left' }}>
                                            <input
                                                style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                                id='process_name'
                                                type="text"
                                                step='any'
                                                className='add-project-input'
                                                placeholder={''}
                                                margin="normal"
                                                name='process_name'
                                                value={this.props.aplicatie.process_name || ''}
                                                onChange={this.props.changeAplicatie}
                                            // onBlur={this.props.updateAngajatData}
                                            />
                                            <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.monitorizare.numeleProcesului}</label>
                                        </div>

                                    </Grid>

                                    <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div style={{ position: 'relative', textAlign: 'left' }}>
                                            <input
                                                style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                                id='process_name_x86'
                                                type="text"
                                                step='any'
                                                className='add-project-input'
                                                placeholder={''}
                                                margin="normal"
                                                name='process_name_x86'
                                                value={this.props.aplicatie.process_name_x86 || ''}
                                                onChange={this.props.changeAplicatie}
                                            // onBlur={this.props.updateAngajatData}
                                            />
                                            <label className='inputLabelPM' htmlFor='telefon'>{this.dictionary.monitorizare.numeleProcesului32}</label>
                                        </div>

                                    </Grid>


                                    <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <select
                                            style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='is_productive'
                                            value={this.props.aplicatie.is_productive}
                                            onChange={this.props.changeAplicatie}
                                        >
                                            {/* <option value={-1}>{this.dictionary.monitorizare.esteProductiva}</option> */}
                                            {/* <option value={'-1'}>Tot Proiectul</option> */}

                                            {this.state.listProductive.map((l, idx) => {
                                                return (
                                                    <option key={idx} value={l.id}>{l.nume}</option>
                                                )
                                            })}

                                        </select>


                                    </Grid>

                                    <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Button
                                            style={{ marginRight: 20 }}

                                            className={'add-button-green'} onClick={() => { this.props.salveazaAplicatie() }}  >

                                            <i style={{
                                                fontSize: 14,
                                                marginRight: 10
                                            }} className='material-icons'>add</i>  {this.dictionary.monitorizare.salveaza}
                                        </Button>

                                        <Button
                                            style={{ marginRight: 20 }}

                                            className={'add-button-red'} onClick={() => { this.props.deleteApp() }}  >

                                            <i style={{
                                                fontSize: 14,
                                                marginRight: 10
                                            }} className='material-icons'>delete</i>  {this.dictionary.monitorizare.sterge}
                                        </Button>

                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    </DialogContent>

                    {/* <h2 className='pm-dialog-alert-title'>{this.props.title}</h2> */}
                    {/* <DialogActions className="pm-dialog-bottom-buttons">




                    </DialogActions> */}


                </Dialog>
            </div>
        );
    }
}